import { SERVICES } from 'tenant/config';
import sendEventToSegment from './sendEventToSegment';
import TrackeableEvent from './TrackeableEvent';
import { HOST } from 'tenant/host_config';

const initAnalytics = async ({ segmentKey }) => {
  if (!SERVICES.SEGMENT) return null;

  if (!segmentKey) {
    console.error('[Segment] No segmentKey provided');
    return;
  }

  if (!window.analytics) {
    console.error('[Segment] No Segment Snippet loaded');
    return;
  }

  if (window.analytics.load) {
    console.log(`[Segment] Loading with key: ${segmentKey}`);
    window.analytics.load(segmentKey);
  }
};

const setSegmentPage = async () => {
  if (!SERVICES.SEGMENT) return null;

  if (!window.analytics || !window.analytics.page) {
    console.error('[Segment] No Segment Snippet loaded');
    return;
  }

  window.analytics.page();
};

const identifyToSegment = async ({ user }) => {
  if (!SERVICES.SEGMENT) return null;

  if (!window.analytics || !window.analytics.identify) {
    console.error('[Segment] No Segment Snippet loaded');
    return;
  }

  console.log(`[Segment] Identify user:`, user);
  window.analytics.identify(user.uuid, {
    name: user.name,
    email: user.email,
    groups: user.groups,
    country: user.country,
  });
};

const identifyToInspectlet = async ({ user } = {}) => {
  if (!SERVICES.INSPECTLET) return null;

  if (!window.__insp || !user) {
    return null;
  }

  window.__insp.push(['identify', user.email]);
  window.__insp.push([
    'tagSession',
    {
      email: user.email,
      id: user.id,
      country: user.country,
      tenant_name: HOST,
    },
  ]);
};

export {
  initAnalytics,
  identifyToSegment,
  identifyToInspectlet,
  setSegmentPage,
  sendEventToSegment,
  TrackeableEvent,
};
